import autismDiagnosisQuestionSet from "../faq/autismDiagnosis/allQuestions";

export const adhdDiagnosis = {
    'meta': {
        'title': 'Diagnostyka ADHD u dorosłych #cityLocativeIn# • Centrum COLLIGO',
        'description': 'Diagnoza ADHD u dorosłych to kompleksowy, 3–6 spotkań proces obejmujący zebranie szczegółowych informacji o trudnościach i historii leczenia, przeprowadzenie wywiadu DIVA 5.0, konsultację psychiatryczną oraz podstawową psychoedukację i dalsze wsparcie.'
    },
    'availability': [
        'torun'
    ],
    'url': {
        'address': '#cityIdUrl#/uslugi/diagnostyka-adhd/',
        'title': 'Diagnostyka ADHD u dorosłych #cityLocativeIn#',
        'name': 'Diagnostyka ADHD u dorosłych #cityLocativeIn#',
        'heading': 'Diagnostyka ADHD u dorosłych #cityLocativeIn#',
        'fullName': 'Diagnostyka ADHD u dorosłych'
    },
    'image': {
        'url': '/images/services/diagnostyka-adhd-w-toruniu.webp',
        'width': 886,
        'height': 295,
        'alt': 'Diagnostyka ADHD u dorosłych #cityLocativeIn#'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/open-graph/diagnostyka-adhd-w-toruniu.webp',
            'width': 886,
            'height': 295,
            'alt': 'Diagnostyka ADHD u dorosłych #cityLocativeIn#'
        }
    },
    'faq': autismDiagnosisQuestionSet
}